import {
  DetailsItemType,
  DetailsState,
  ServiceType,
  SummaryType,
} from '@/@types/billing/details'

export const deleteSummaryItemByServiceCodeType = (
  summaryArray: SummaryType[],
  serviceCodeType: string
): SummaryType[] => {
  try {
    if (!serviceCodeType) throw new Error('Incomplete data')

    if (summaryArray.length === 0) throw new Error('Incomplete data')

    summaryArray = summaryArray.filter(
      (summaryItem: SummaryType) =>
        summaryItem.batServiceCodeType !== serviceCodeType
    )

    return summaryArray
  } catch (error) {
    return summaryArray ? summaryArray : []
  }
}

export const deleteDetailsItemByServiceCodeType = (
  detailsArray: DetailsItemType[],
  serviceCodeType: string
): DetailsItemType[] => {
  try {
    if (!serviceCodeType) throw new Error('Incomplete data')

    if (detailsArray.length === 0) throw new Error('Incomplete data')

    detailsArray = detailsArray.filter(
      (detailsItem: DetailsItemType) =>
        detailsItem.beServiceCode.slice(0, 2) !== serviceCodeType
    )

    return detailsArray
  } catch (error) {
    return detailsArray ? detailsArray : []
  }
}

export const deleteServiceItemByServiceCodeType = (
  serviceArray: ServiceType[],
  serviceCodeType: string
): ServiceType[] => {
  try {
    if (!serviceCodeType) throw new Error('Incomplete data')

    if (serviceArray.length === 0) throw new Error('Incomplete data')

    serviceArray = serviceArray.filter(
      (serviceItem: ServiceType) =>
        serviceItem.serviceCodeType !== serviceCodeType
    )

    return serviceArray
  } catch (error) {
    return serviceArray ? serviceArray : []
  }
}

export const deleteBulkServiceAndDetailsAndSummary = (
  details: DetailsState
): DetailsState => {
  try {
    if (
      !details.summary ||
      !Array.isArray(details.summary) ||
      details.summary.length === 0
    )
      throw new Error('Incomplete data')

    details.summary.forEach((summaryItem: SummaryType) => {

      const batServiceCodeType = summaryItem.batServiceCodeType

      if (Number(summaryItem.batServiceUseDay) === 0) {
        details.summary = deleteSummaryItemByServiceCodeType(
          details.summary,
          batServiceCodeType
        )

        details.details = deleteDetailsItemByServiceCodeType(
          details.details,
          batServiceCodeType
        )

        details.service = deleteServiceItemByServiceCodeType(
          details.service,
          batServiceCodeType
        )
      }
    })

    return details
  } catch (error) {
    return details
  }
}
